import {CalendarView} from 'angular-calendar';

export enum GitsCalendarView {
  Month = 'month',
  Week = 'week',
  Day = 'day',
  Custom = 'custom',
  Table = 'table'
}
